import { Box, Divider, Flex, Tag } from '@chakra-ui/react';

import SunshineCard from '../../../../../../../../components/_core/SunshineCard';
import SunshineIcon from '../../../../../../../../components/_core/SunshineIcon';
import Text from '../../../../../../../../components/_core/Text';
import locales from './locales';

export enum CompanyCardStatuses {
  Pending = 'pending',
  Verifying = 'verifying',
  Error = 'error',
}

interface CompanyCardProps {
  status: CompanyCardStatuses;
  name?: string;
}

const statusProps = {
  [CompanyCardStatuses.Pending]: {
    content: locales.pendingStatus,
    tagColor: 'yellow',
    tagContent: locales.pendingTag,
  },
  [CompanyCardStatuses.Verifying]: {
    content: locales.verifyingStatus,
    tagColor: 'blue',
    tagContent: locales.verifyingTag,
  },
  [CompanyCardStatuses.Error]: {
    content: locales.errorStatus,
    tagColor: 'red',
    tagContent: locales.errorTag,
  },
};

const CompanyCard = ({ name, status }: CompanyCardProps) => {
  const { content, tagColor, tagContent } = statusProps[status];
  return (
    <SunshineCard padding={0}>
      <SunshineCard.Content>
        <Flex alignItems="center" padding="space-16" width="100%">
          <Box
            backgroundColor="grey.200"
            borderRadius="radius-12"
            display="flex"
            padding="space-10"
          >
            <SunshineIcon name="misc" size="icon-20" />
          </Box>
          <Text
            flex={1}
            fontWeight="500"
            marginX="space-16"
            overflowWrap="anywhere"
            variant="primary"
          >
            {name}
          </Text>
          <Tag backgroundColor={`${tagColor}.200`} color={`${tagColor}.700`}>
            {tagContent}
          </Tag>
        </Flex>
        <Divider />
        <Text padding="space-16">{content}</Text>
      </SunshineCard.Content>
    </SunshineCard>
  );
};

export default CompanyCard;
